import React from 'react';
import { Box, Container, Typography,  Link } from '@mui/material';
import { motion } from 'framer-motion'
import one from '../../assets/one.avif'
import two from '../../assets/two.avif'
import three from '../../assets/three.avif'
import four from '../../assets/four.avif'

const categories = [
    {
        title: "Ethnic Wear",
        image: one,
        size: 'large',
        gridArea: '1 / 1 / 3 / 2'
    },
    {
        title: "Western Wear",
        image: two,
        size: 'wide',
        gridArea: '1 / 2 / 2 / 4'
    },
    {
        title: "Casual Chic",
        image: three,
        size: 'small',
        gridArea: '2 / 2 / 3 / 3'
    },
    {
        title: "Festive Edit",
        image: four,
        size: 'small',
        gridArea: '2 / 3 / 3 / 4'
    }
];

const CategoryCard = ({ category, index }) => {
    return (
        <Box
            component={motion.div}
            initial={{ y: 60, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.4 }} // Increased from 0.2
            transition={{ duration: 0.8, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ scale: 0.98 }}
            sx={{
                position: 'relative',
                gridArea: category.gridArea,
                height: '100%',
                minHeight: category.size === 'large' ? 800 : category.size === 'wide' ? 390 : 390,
                overflow: 'hidden',
                borderRadius: '2px',
                cursor: 'pointer',
                '&:hover .category-overlay': {
                    backgroundColor: 'rgba(0,0,0,0.4)',
                },
                '&:hover img': {
                    scale: '1.05',
                }
            }}
        >
            <Box
                component="img"
                src={category.image}
                alt={category.title}
                sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'scale 0.6s ease',
                }}
            />
            <Box
                className="category-overlay"
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.25)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    p: 4,
                    transition: 'background-color 0.4s ease',
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        color: 'white',
                        fontFamily: "'cormorantgaramond', serif",
                        fontWeight: 700,
                        fontSize: '2rem',
                        mb: 0.5
                    }}
                >
                    {category.title}
                </Typography>
                <Link
                    href="#"
                    sx={{
                        color: 'white',
                        textDecoration: 'none',
                        fontFamily: "'Sora', sans-serif",
                        fontSize: '0.8rem',
                        fontWeight: 600,
                        letterSpacing: '0.1em',
                        textTransform: 'uppercase',
                        opacity: 0.9,
                        borderBottom: '1px solid white', // Added elegant underline
                        pb: 0.5,
                        width: 'fit-content',
                        '&:hover': {
                            opacity: 1,
                        }
                    }}
                >
                    SHOP NOW
                </Link>
            </Box>
        </Box>
    );
};

const CategoryGrid = () => {
    return (
        <Box sx={{ py: 12, backgroundColor: 'transparent' }}>
            <Container maxWidth="xl">
                <Box
                    component={motion.div}
                    initial={{ y: 40, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    sx={{ textAlign: 'center', mb: 8 }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Sora', sans-serif",
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            letterSpacing: '0.2em',
                            color: '#999',
                            mb: 1.5
                        }}
                    >
                        EXPLORE THE COLLECTION
                    </Typography>
                    <Typography
                        variant="h2"
                        className="font-heading"
                        sx={{
                            fontSize: '4rem',
                            fontWeight: 800,
                            color: '#1a1a1a',
                            lineHeight: 1.2
                        }}
                    >
                        Curated Categories
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '2fr 1fr 1fr' }, // Left column is now 50% (2/4)
                        gridTemplateRows: { xs: 'auto', md: 'repeat(2, 400px)' },
                        gap: 2,
                    }}
                >
                    {categories.map((cat, index) => (
                        <CategoryCard key={index} category={cat} index={index} />
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default CategoryGrid;
